import '../../style/';
import '../../tabs/style/';
import './index.less';
import '../../badge/style/';



// WEBPACK FOOTER //
// ./components/tab-bar/style/index.tsx